import { useRef } from "react";
import { NotificacaoConfiguracaoForm } from "features/robo-cobranca/typings";
import { Control, UseFormWatch } from "react-hook-form";
import { Modal } from "antd";
import OutlineButton from "ui/components/Button/OutlineButton";
import { CgTemplate } from "react-icons/cg";
import { Flex, Text, Box } from "@chakra-ui/layout";
import Field from "components/Input/Field";
import MessageEditor from "ui/components/MessageEditor";
import TagsVariaveisTemplate from "./../TagsVariaveisTemplate/index";

interface ModalTemplateEmailProps {
  titulo: string;
  control: Control<NotificacaoConfiguracaoForm>;
  parentIndex: number;
  watch: UseFormWatch<NotificacaoConfiguracaoForm>;
  tipoNotificacaoId: string;
  isOpen: boolean;
  onClose: () => any;
}

function ModalTemplateEmail({
  titulo,
  control,
  parentIndex,
  watch,
  tipoNotificacaoId,
  isOpen,
  onClose,
}: ModalTemplateEmailProps) {
  const editorRef = useRef<any>(null);

  return (
    <Modal
      onCancel={onClose}
      visible={isOpen}
      width="800px"
      footer={
        <OutlineButton onClick={onClose} ml="auto">
          Fechar
        </OutlineButton>
      }
    >
      <Flex gap="4px" alignItems={"center"}>
        <CgTemplate fontSize={20} />
        <Text fontSize="18px" fontWeight="500">
          Modelo de Email - {titulo}
        </Text>
      </Flex>

      <Field
        control={control}
        name={`tipos.${parentIndex}.templateEmail`}
        render={({ field }) => (
          <Flex flexDir="column">
            <MessageEditor
              value={field.value}
              onChange={field.onChange}
              setRef={(ref) => (editorRef.current = ref)}
            />

            <Box mt={4}>
              <Text fontWeight="medium">
                Variáveis (clique para inserir, ou digite)
              </Text>
              <TagsVariaveisTemplate
                onClickVariavel={(v) => {
                  if (editorRef.current) {
                    editorRef.current?.model?.change?.((writer: any) => {
                      const insertPosition =
                        editorRef.current.model.document.selection.getFirstPosition();

                      writer.insertText(v, insertPosition);
                    });
                  } else {
                    field.onChange(`${field.value} ${v}`);
                  }
                }}
              />
            </Box>
          </Flex>
        )}
      />
    </Modal>
  );
}

export default ModalTemplateEmail;
